import React, { useEffect, useState, useRef } from 'react';
import DevotionalWeeklyCard from './devotionalWeeklyCard';


function ArticleSkeleton() {
  return (
    <div className="dna-article-card dna-skeleton-card" aria-hidden="true">
      <div className="dna-card-thumb dna-skeleton-box" />
      <div className="dna-card-body">
        <div className="dna-skeleton-line dna-skeleton-line--title" />
        <div className="dna-skeleton-line dna-skeleton-line--desc" />
        <div className="dna-skeleton-line dna-skeleton-line--desc dna-skeleton-line--short" />
      </div>
    </div>
  );
}


const WeeklyStotrasnSahasranamalu = ({ cat_id, ssrData = {},ssrCatId }) => {
  const getCombinedData = (source) => {
    let stotra = source.devotional_weekly_stotra_content || [];
    let sahasra = source.devotional_weekly_sahasra_content || [];

   const filteredStotra = Array.isArray(stotra) && stotra.length > 0
  ? stotra
      .filter(item => item.msg !== "No Data Found")
      .map(item => ({
        img: item.image,
        title: item.title,
        url: item.url,
      }))
  : [];

const filteredSahasra = Array.isArray(sahasra) && sahasra.length > 0
  ? sahasra
      .filter(item => item.msg !== "No Data Found")
      .map(item => ({
        img: item.image,
        title: item.title,
        url: item.url,
      }))
  : [];

    return [...filteredStotra, ...filteredSahasra];
  };

  const initialData = getCombinedData(ssrData);

  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const lastFetchedCatId = useRef(cat_id);
  const itemsPerPage = 6;

  useEffect(() => {



    const fetchData = async () => {
      setLoading(true);
      setError(null);
     
      try {
        const res = await fetch(`https://www.teluguone.com/devotional_api/devotionalWeeklyArticlesContentJson?cat_id=${cat_id}&start=0&limit=100`);
        if (!res.ok) throw new Error('Failed to fetch content.');

        const jsonData = await res.json();
        const combined = getCombinedData(jsonData);

        setData(combined);
        setCurrentPage(1); 
        lastFetchedCatId.current = cat_id
      } catch (e) {
        setError(e.message || 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    const isSameCategory = lastFetchedCatId.current === cat_id === ssrCatId;

    if (initialData.length && isSameCategory) {
      setLoading(false);
      lastFetchedCatId.current = cat_id
      return;
    }
    setData(null)
    fetchData();
  }, [cat_id]);

  const totalPages = Math.ceil(data?.length / itemsPerPage);
  const paginatedData = data?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (page) => setCurrentPage(page);

  if (loading) {
    return (
      <div className="row">
        {[...Array(4)].map((_, index) => (
          <div className="col-12 col-sm-6" key={index}>
            <ArticleSkeleton />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="row">
        <div className="col-12">
          <div className="json-loading-error-div text-center">
            <img src="/devotional/assets/images/json_error.png" alt="json_error" />
            <p className="text-danger">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row g-0" style={{border:"1px solid #e8ddd0",backgroundColor:"#e8ddd0"}} >
      <div className="col-12 devotional-videos-header">Stotralu / Sahasranamalu</div>

      {Array.isArray(paginatedData) &&  paginatedData.map((item, index) => (
        <DevotionalWeeklyCard item={item} key={item.url || index} index={index} />
      ))}

      {totalPages > 1 && (
        <div className="col-12 d-flex justify-content-center flex-wrap mt-3 gap-1 mb-2">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => handlePageChange(i + 1)}
              className={`btn ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default WeeklyStotrasnSahasranamalu;
